/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Tracks which pre-send review items on a ticket draft have been explicitly
 * addressed with the user, so send_support_ticket only unlocks once every item
 * has an answer. Asked one by one, description, environment, business impact and
 * priority all need a real answer and cannot be declined, while CC is valid once
 * asked-and-declined; a user who approves the whole list answers every item at
 * once, which keeps the priority the card shows and records no business impact
 * and nobody in CC.
 * @export
 * @interface TicketReviewState
 */
export interface TicketReviewState {
    /**
     * 
     * @type {boolean}
     * @memberof TicketReviewState
     */
    descriptionConfirmed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketReviewState
     */
    environmentConfirmed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketReviewState
     */
    businessImpactConfirmed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketReviewState
     */
    ccConfirmed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketReviewState
     */
    priorityConfirmed?: boolean;
}

/**
 * Check if a given object implements the TicketReviewState interface.
 */
export function instanceOfTicketReviewState(value: object): value is TicketReviewState {
    return true;
}

export function TicketReviewStateFromJSON(json: any): TicketReviewState {
    return TicketReviewStateFromJSONTyped(json, false);
}

export function TicketReviewStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketReviewState {
    if (json == null) {
        return json;
    }
    return {
        
        'descriptionConfirmed': json['description_confirmed'] == null ? undefined : json['description_confirmed'],
        'environmentConfirmed': json['environment_confirmed'] == null ? undefined : json['environment_confirmed'],
        'businessImpactConfirmed': json['business_impact_confirmed'] == null ? undefined : json['business_impact_confirmed'],
        'ccConfirmed': json['cc_confirmed'] == null ? undefined : json['cc_confirmed'],
        'priorityConfirmed': json['priority_confirmed'] == null ? undefined : json['priority_confirmed'],
    };
}

export function TicketReviewStateToJSON(json: any): TicketReviewState {
    return TicketReviewStateToJSONTyped(json, false);
}

export function TicketReviewStateToJSONTyped(value?: TicketReviewState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description_confirmed': value['descriptionConfirmed'],
        'environment_confirmed': value['environmentConfirmed'],
        'business_impact_confirmed': value['businessImpactConfirmed'],
        'cc_confirmed': value['ccConfirmed'],
        'priority_confirmed': value['priorityConfirmed'],
    };
}

